export const ProjetBadge = ({ show, code }) => show ? (
  <span className="rounded-full border border-orange-300 bg-orange-100 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-orange-700" title="Fiche en projet, non publiée au Journal officiel : montant indicatif" data-testid={`projet-badge-${code}`}>Projet</span>
) : null;
